const hasPermission = (state, getters, rootState, rootGetters) => {
    return rootGetters['auth/appAccesses']?.includes('LEASING');
};

const getDocumentInstance = state => state.document_instance;
const getLease = state => state.lease;
const getESignature = state => state.e_signature;
const bluemoon_credentials = state => state.blue_moon_credentials;
const isKeyUpdated = state => state.isKeyUpdated;
const isLeaseCreationExecuted = state => state.isLeaseCreationExecuted;
const isLeaseSignatureExecuted = state => state.isLeaseSignatureExecuted;
const isLeaseDownloadExecuted = state => state.isLeaseDownloadExecuted;
const getTransactions = state => state.credits;

export default {
    hasPermission,
    getDocumentInstance,
    getLease,
    getESignature,
    bluemoon_credentials,
    isKeyUpdated,
    isLeaseCreationExecuted,
    isLeaseSignatureExecuted,
    isLeaseDownloadExecuted,
    getTransactions,
};
